<!-- 重置组件 -->
<template>
  <el-dialog :visible="openTopUp" @close="close" custom-class="topup" width="620px">
    <section class="header" slot="title">
      <div class="userInfo">
        <img :src="logo + '?x-oss-process=image/resize,m_mfit,h_35'" alt="">
        <div>
          <div class="name">
            <span>{{ userInfo.userInfo.nickName }}</span>
            <div class="PNT">
              <img src="../assets/编组 2@2x.png" alt="">
              <span>{{ balance }}</span>
            </div>
          </div>
          <div class="vipInfo">
            {{ userInfo.orgInfo.isVip ? '您还不是会员' : vipInfo.vipTypeName }}
          </div>
        </div>
      </div>
    </section>
    <section class="body">
      <div class="packageInfo">
        <div @click="selectPackage(item, i)" v-for="(item, i) in packageList" :key="i" :class="['packageItem', { active: i === curActive }]">
          <div class="dotNum">
            <span v-if="!item.isCustom">{{ item.count }}点</span>
            <span v-else>{{ item.title }}</span>
          </div>
          <div class="priceInfo">
            <span class="unit">¥</span>
            <span class="price">{{ item.price }}</span>
          </div>
          <div v-if="item.showTag" class="tag"> 享更多权益 </div>
        </div>
      </div>
      <div :class="['payment', { openVip: curActive >= 2 }]">
        <ul>
          <li>
            {{ curPackage.count || 10000 }}点约可生图{{ Math.floor(curPackage.count / 2) || 5000 }}张，或可编辑处理图片{{ Math.floor(curPackage.count / 2) || 5000 }}次
          </li>
          <li>充值的点数1年内有效</li>
          <li>点数充值不退不换</li>
        </ul>
        <div class="payContent">
          <div v-if="!showContact" class="payBox">
            <div v-loading="loading" class="qrcodeBox">
              <img v-if="qrCodeImg" :src="qrCodeImg" alt="">
              <div v-if="isInvalid" class="pastDue">
                <i @click="refreshQRCode" class="el-icon-refresh"></i>
                <div>二维码已失效,点击刷新</div>
              </div>
            </div>
            <div class="payInfo">
              <div class="payMoney">实付：<span>¥ <span>{{ curPackage.price }}</span></span></div>
              <div class="payWay">
                <div @click="switchPayWay(2)" :class="{ active: payWay === 2 }">
                  <img src="https://static.iyw.cn/GenerateAI/top_up/weixinPay.png" alt="">
                  <span>微信支付</span>
                </div>
                <div @click="switchPayWay(1)" :class="{ active: payWay === 1 }">
                  <img src="https://static.iyw.cn/GenerateAI/top_up/aliPay.png" alt="">
                  <span>支付宝</span>
                </div>
              </div>
              <div class="tips">
                支付即视为同意<a href="https://static.iyw.cn/protocol/AIAgreement.html" target="_blank">相关协议</a>条例
              </div>
            </div>
          </div>
          <div v-else class="openVipBox">
            <button @click="sendWorkOrderChat('open')">VIP开通会员，解锁权益</button>
          </div>
        </div>
      </div>
    </section>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RecvMsgParser, getUserInfo } from "@/service/GenerateAI/index";
import QRCode from "qrcode";
import {
  GetComputingPowerVipType,
  GetDosingPackageList,
  SendRechargeAIMsg,
  GetMemberQRCode,
  PayPCOrderQuery,
  GetUserVipInfo
} from "../service/GenerateAI/topUp";
export default {
  data() {
    return {
      vipInfo: {}, // 会员信息
      userInfo: {
        userInfo: {},
        orgInfo: {}
      }, // 用户信息
      curActive: 0,
      showContact: false, // 是否显示联系
      packageList: [], // 套餐列表
      powerVipType: {}, // 算力会员类型
      openPackage: [ // 开通会员的展示列表
        { showTag: true, price: 9800, title: '升级会员', isCustom: true },
        { showTag: true, price: 15800, title: '升级会员', isCustom: true },
      ],
      curPackage: {}, // 当前选择的套餐
      payWay: 2, // 支付方式 1 支付宝 2 微信
      qrCodeImg: '', // 二维码图片
      loading: false, // 二维码加载状态
      payOrderNo: '', // 支付订单号
      timer: null, // 定时器
      firstTimer: null, // 首次定时器
      isInvalid: false, // 二维码失效状态
      fail: ['未付款交易超时关闭，或支付完成后全额退款', '交易结束，不可退款', '支付失败', '已关闭', '已撤销'] // 失败订单信息
    }
  },
  computed: {
    ...mapGetters(['openTopUp', 'balance', 'logo'])
  },
  watch: {
    openTopUp(val) {
      if (val) {
        clearTimeout(this.timer)
        clearTimeout(this.firstTimer)
        this.init();
        this.getUserVipInfo();
        this.getUser();
        this.getComputingPowerVipType();
      }
    }
  },
  methods: {
    ...mapActions(['updateBalance']),
    // 刷新二维码
    refreshQRCode() {
      this.isInvalid = false;
      this.getQRCode();
    },
    // 切换支付方式
    switchPayWay(way) {
      this.payWay = way;
      this.getQRCode();
    },
    // 选择套餐
    selectPackage(item, i) {
      this.curPackage = item
      if (item.isCustom) {
        this.showContact = true
        clearTimeout(this.timer)
      } else {
        this.showContact = false
        this.getQRCode();
      }
      this.curActive = i;
    },
    // 关闭弹窗
    close() {
      clearTimeout(this.timer)
      if (this.firstTimer) {
        clearTimeout(this.firstTimer)
      }
      this.$store.commit('SET_OPEN_TOPUP', false);
    },
    init() {
      this.payOrderNo = ''
      this.qrCodeImg = ''
      this.loading = false
      this.showContact = false
      this.curActive = 0
      this.curPackage = {}
      this.payWay = 2
    },
    // 获取支付二维码
    async getQRCode() {
      clearTimeout(this.timer)
      this.loading = true;
      if (this.firstTimer) {
        clearTimeout(this.firstTimer)
      }
      const res = await GetMemberQRCode({
        typeId: this.curPackage.typeId,
        payMethod: this.payWay,
        device: 1,
        amount: 1
      });
      if (res.code == 1) {
        this.payOrderNo = res.data.payOrderNo;
        this.qrCodeImg = await QRCode.toDataURL(res.data.qrCode, {
          errorCorrectionLevel: 'H',
          type: 'image/png',
          quality: 1,
          margin: 1,
          width: 118,
          height: 118
        });
        this.firstTimer = setTimeout(() => {
          clearTimeout(this.firstTimer)
          this.getPayStatus();
        }, 3000)
      }
      this.loading = false;
    },
    // 获取支付状态
    async getPayStatus() {
      const res = await PayPCOrderQuery({ payOrderNo: this.payOrderNo })
      if (res.code == 1) {
        this.$alert(
          `您已充值成功${this.curPackage.count}点数，可前往智物AI使用`,
          "提示",
          {
            confirmButtonText: "我知道了",
            callback: () => { },
          }
        );
        this.sendWorkOrderChat('recharge');
        this.updateBalance()
        this.$store.commit('SET_OPEN_TOPUP', false);
      } else {
        if (this.fail.includes(res.message)) {
          this.isInvalid = true;
          clearTimeout(this.timer)
        } else {
          this.timer = setTimeout(() => {
            this.getPayStatus()
          }, 3000)
        }
      }
    },
    // 获取算了充值类型
    async getComputingPowerVipType() {
      const res = await GetComputingPowerVipType();
      if (res.code == 1) {
        this.powerVipType = res.data;
        if (this.powerVipType.type == 1) {
          this.getPackageList();
        } else {
          this.packageList = this.openPackage
          this.selectPackage(this.openPackage[0], 0)
        }
      }
    },
    // 获取套餐列表
    async getPackageList() {
      const res = await GetDosingPackageList({ alias: 'costPoints' });
      if (res.code == 1) {
        this.packageList = res.data
        this.packageList.push(this.openPackage[0])
        this.selectPackage(this.packageList[0], 0)
      }
    },
    // 发送工单消息
    sendWorkOrderChat(type) {
      if (this.powerVipType.isDesigner) {
        this.sendRechargeMsg()
      } else {
        this.sendWorkOrderMsg(type)
      }
    },
    // 埋点工单消息
    async sendWorkOrderMsg(type) {
      const msgCode = type == 'open' ? 'C-AIKTHY' : 'C-AICZDS';
      const tips = type == 'open' ? `客户在智物AI中申请开通${this.curPackage.price}会员，请及时跟进` : `客户在智物AI中成功充值了${this.curPackage.count}点数`;
      // 其他推送的消息
      RecvMsgParser({
        Equipment: "pc",
        registerSource: "1",
        Mobile: this.userInfo.userInfo.phone,
        CaihongNo: this.userInfo.orgInfo.caihongNO,
        platForm: "AI生成平台",
        name: this.userInfo.userInfo.name,
        msgHandlecode: msgCode,
        content: tips,
      }).then(() => { });
      if (type == 'open') {
        this.$alert(
          "您的申请已收到，工作人员将于1个工作日内与您联系，也可以咨询顾问",
          "提示",
          {
            confirmButtonText: "我知道了",
            callback: () => { },
          }
        );
      }
    },
    // 设计师消息推送
    async sendRechargeMsg() {
      const res = await SendRechargeAIMsg({
        type: this.curPackage.isCustom ? 2 : this.powerVipType.type,
        content: this.curPackage.isCustom ? this.curPackage.price : this.curPackage.count,
      });
      console.log('设计师消息推送', res);
    },
    // 获取用户信息
    async getUser() {
      const res = await getUserInfo()
      if (res.code == 1) {
        this.userInfo = res.data;
      }
    },
    // 获取用户vip信息
    async getUserVipInfo() {
      const res = await GetUserVipInfo()
      if (res.code == 1) {
        this.vipInfo = res.data;
      }
    }
  },
}

</script>
<style lang="scss">
.topup {
  .el-dialog__header {
    padding: 0;

    .el-dialog__close {
      font-size: 20px;
      color: #AAAAAA;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 20px 26px;
    background-image: url(https://static.iyw.cn/GenerateAI/top_up/head.png);
    background-size: 100%;

    .userInfo {
      display: flex;
      align-items: center;

      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
      }

      &>div {
        .name {
          display: flex;
          align-items: center;
          margin-bottom: 3px;

          &>span {
            font-size: 16px;
            font-weight: 600;
            color: #333;
          }

          .PNT {
            display: flex;
            align-items: center;
            margin-left: 6px;
            height: 22px;
            border-radius: 11px;
            line-height: 22px;
            padding: 0 6px;
            background: linear-gradient(107deg, #2858F8 0%, #00B7FF 100%);

            img {
              width: 16px;
              height: 16px;
              margin-right: 1px;
            }

            span {
              font-size: 14px;
              color: #fff;
            }
          }
        }

        .vipInfo {
          font-size: 13px;
          color: #6F717E;
        }
      }
    }
  }

  .body {
    background-color: #F5F6FA;
    padding: 16px 20px 26px;
    overflow: hidden;

    .packageInfo {
      width: 100%;
      overflow-x: auto;
      display: flex;
      align-items: center;

      .packageItem {
        position: relative;
        background-color: #fff;
        width: 180px;
        height: 115px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 2px solid transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #333333;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 20px;
        }

        &.active {
          color: #2858F8;
          border-color: #2858F8;
        }

        .dotNum {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .priceInfo {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 10px;
          display: flex;
          align-items: flex-end;
          line-height: 100%;

          .unit {
            font-size: 20px;
            margin-right: 4px;
            line-height: 22px;
          }

          .price {
            font-size: 24px;
          }
        }

        .tag {
          position: absolute;
          right: -1px;
          top: -1px;
          padding: 1px 6px;
          font-size: 12px;
          color: #FFFFFF;
          border-radius: 0 6px 0 6px;
          background: linear-gradient(113deg, #FD2512 0%, #FD8453 100%);
        }
      }
    }

    .payment {
      margin-top: 16px;
      background-color: #fff;
      padding: 18px;
      border-radius: 6px;
      height: 268px;
      background-size: 100%;
      display: flex;
      flex-direction: column;

      &.openVip {
        background-image: url(https://static.iyw.cn/GenerateAI/top_up/mainBg.png);
      }

      ul {
        color: #6F717E;
        list-style: disc;
        padding-left: 18px;

        li {
          margin-bottom: 11px;
        }
      }

      .payContent {
        flex: 1;

        .payBox {
          display: flex;
          align-items: center;
          padding-top: 20px;

          .qrcodeBox {
            position: relative;
            width: 118px;
            height: 118px;
            margin-right: 23px;

            img {
              width: 100%;
              height: 100%;
            }

            .pastDue {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background-color: rgba(0, 0, 0, 0.5);
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              color: #FFFFFF;
              padding: 15px;

              &>i {
                font-size: 25px;
                cursor: pointer;
              }

              &>div {
                text-align: center;
                font-size: 12px;
                margin-top: 12px;
              }
            }
          }

          .payInfo {
            .payMoney {
              color: #6F717E;
              font-size: 19px;
              margin-bottom: 12px;

              &>span {
                color: #FF4040;

                &>span {
                  font-size: 25px;
                }
              }
            }

            .payWay {
              margin-bottom: 19px;
              display: flex;

              &>div {
                width: 122px;
                height: 40px;
                border: 1px solid #EEEEEE;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                cursor: pointer;

                &.active {
                  border-color: #2858F8;
                }

                &:not(:last-child) {
                  margin-right: 14px;
                }

                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 10px;
                }

                span {
                  font-size: 14px;
                  color: #333333;
                }
              }
            }

            .tips {
              color: #6F717E;
              font-size: 13px;

              a {
                color: #2858F8;
              }
            }
          }
        }

        .openVipBox {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          button {
            color: #663E02;
            width: 242px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 22px;
            border: none;
            background-color: #FEDD87;
            cursor: pointer;
            font-weight: 600;

            &:active {
              opacity: 0.75;
            }
          }
        }
      }
    }
  }
}
</style>